<template>
  <div class="h-full flex flex-col">
    <div class="dashboard-controls">
      <div class="container-fluid pt-3 pb-3 px-4 flex-wrap">
        <div class="row pl-3 pr-3">
          <h1 class="mr-auto p-2">Map</h1>
          <div class="d-flex">
            <div class="col-md scrolleable">
              <p class="mb-1">Appointment Status</p>
              <form id="jobs-filter-form">
                <input
                  id="service_date"
                  type="hidden"
                  name="service_date"
                  :value="queryParam || initialData?.today"
                  autocomplete="off"
                />
                <EnumFilter
                  v-if="initialData"
                  v-bind="initialData?.filterOptions"
                />
              </form>
            </div>
            <div class="mr-3">
              <p class="mb-1">Date</p>
              <div class="d-flex mt-2 mt-md-0">
                <span class="btn-group btn-group-toggle" data-toggle="buttons">
                  <label
                    id="map_yesterday"
                    class="btn btn-outline-secondary btn-sm map_date_arrows"
                  >
                    <input
                      id="option1"
                      type="radio"
                      name="options"
                      autocomplete="off"
                    />
                    <i class="fa fa-chevron-left fa-fw"></i>
                  </label>
                  <label class="btn btn-outline-secondary btn-sm active">
                    <input
                      id="option2"
                      type="radio"
                      name="options"
                      autocomplete="off"
                      checked
                    />
                    {{ queryParam || "Today" }}
                  </label>
                  <label
                    id="map_tomorrow"
                    class="btn btn-outline-secondary btn-sm map_date_arrows"
                  >
                    <input
                      id="option3"
                      type="radio"
                      name="options"
                      autocomplete="off"
                    />
                    <i class="fa fa-chevron-right fa-fw"></i>
                  </label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <input
      id="socket-config"
      type="hidden"
      :value="JSON.stringify(initialData?.socketConfig)"
    />
    <input id="tenant-subdomain" type="hidden" value="" />
    <Cluster v-if="initialData" />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";

import EnumFilter from "@/Map/EnumFilter.vue";
import Cluster from "@/MapCluster/Cluster.vue";

const initialData = ref<{
  today: string;
  filterOptions: any;
  socketConfig: string;
} | null>(null);

const urlParams = new URLSearchParams(window.location.search);
const queryParam = urlParams.get("service_date");

onMounted(async () => {
  const res = await fetch(`${window.location.pathname}/initial_page_data`, {
    method: "GET"
  });
  initialData.value = await res.json();
});
</script>
